import { createContext } from 'react';
import Group from '../models/Group';
import { EntityKind } from '../models/User';

const defaultGroup = new Group({
  ['@id']: '-1',
  id: -1,
  organizationId: -1,
  name: '',
  logoRemotePath: '',
});

const defaultValue = Object.assign(defaultGroup, {
  entityId: -1,
  baseId: -1,
  entityKind: EntityKind.ORGANIZATION,
  readOnly: false,
  entityName: '',
});

export const EntityContext = createContext(defaultValue);
